// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/** Text color for old (removed/overwritten) values — red strikethrough. */
/** Text color for new (added/replacement) values — green. */
/** Row background for wholly new rows (component or valve added in this revision). */
/** Row background for wholly deleted rows (present in previous revision, absent in current). */
/** Text color for deleted row cells (dark red, pairs with \$compare-row-deleted-bg). */
/** Text color for new row cells (dark green, pairs with \$compare-row-new-bg). */
.main-container {
  display: flex;
  flex-direction: column;
}

.close-button-container {
  display: flex;
  justify-content: right;
  padding: 2% 3%;
}

#mat-close-btn {
  cursor: pointer;
}
#mat-close-btn fa-icon {
  color: #707070;
}

#mat-close-btn:hover fa-icon {
  color: #0b2d71;
}

.text-container {
  flex: 1 1 auto;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  padding: 5% 3%;
}
.text-container .dialog-title {
  margin: 0 0 8px 0;
  font-size: large;
  font-weight: bold;
  color: #0066b2;
}
.text-container #title {
  font-size: large;
  font-weight: bold;
}
.text-container .input-container {
  margin-top: 16px;
}
.text-container .input-container .full-width {
  width: 100%;
}
.text-container .input-container .note-textarea {
  resize: vertical;
  min-height: 120px;
}

.buttons-container {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  padding-bottom: 3%;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
